import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ServiceReminderService } from 'src/app/_services/service-reminder.service';
import { VehiclesService } from 'src/app/_services/vehicles.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-create-service-reminder',
  templateUrl: './create-service-reminder.component.html',
  styleUrls: ['./create-service-reminder.component.scss'],
})
export class CreateServiceReminderComponent implements OnInit {
  vehicle_id: any;
  vehicle_references: any = [];
  vehicleList: any[] = [];
  loading: boolean = false;
  date: string = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  services$: Subject<any> = new Subject<any>();
  serviceForm = this.fb.group({
    service_delta: [''],
    service_due_date: ['', Validators.required],
    vehicle_reference: ['', Validators.required],
    vehicle_id: [''],
    km_reading: [''],
  });

  constructor(
    private fb: FormBuilder,
    private serviceReminderService: ServiceReminderService,
    private vehiclesService: VehiclesService,
    public ref: DynamicDialogRef,
    public messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.vehiclesService.getVehicles().subscribe((vehicles: any[]) => {
      this.vehicleList = vehicles
        .map((vehicle) => ({
          vehicle_reference: vehicle.vehicle_reference,
        }))
        .sort((a: any, b: any) =>
          a.vehicle_reference.localeCompare(b.vehicle_reference)
        );
    });

    this.serviceForm = this.fb.group({
      service_delta: [''],
      service_due_date: [this.date, Validators.required],
      vehicle_reference: ['', Validators.required],
      vehicle_id: [''],
      km_reading: [''],
    });
  }

  createReminder() {
    this.loading = true;
    // console.log(this.serviceForm.invalid);

    if (this.serviceForm.invalid) {
      this.loading = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please fill in all the required fields',
      });
      return;
    }

    let vehicle_reference: string =
      this.serviceForm.get('vehicle_reference')!.value!;
    this.vehiclesService
      .getVehicleByReference(vehicle_reference)
      .subscribe((data) => {
        this.vehicle_id = data.body.id;
        const rawDate = this.serviceForm.get('service_due_date')!.value;
        this.serviceForm.patchValue({
          vehicle_id: this.vehicle_id,
          service_due_date: rawDate
            ? formatDate(rawDate, 'yyyy-MM-dd', 'en')
            : this.date,
        });
        // console.log(this.serviceForm.value);

        // km_reading and service_delta are both optional in this form, but
        // an untouched number input still submits '' rather than omitting
        // the key - the backend's Optional[int] fields reject '' (not a
        // valid integer) the same as a required field would, so blank ones
        // must be dropped from the payload rather than sent as ''.
        const payload = { ...this.serviceForm.value };
        if (payload.km_reading === '' || payload.km_reading === null) {
          delete payload.km_reading;
        }
        if (payload.service_delta === '' || payload.service_delta === null) {
          delete payload.service_delta;
        }

        this.serviceReminderService
          .addReminder(payload)
          .subscribe(
            (data) => {
              this.ref.close(data);
            },
            (error) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Service reminder not created',
                key: 'service_reminder',
              });
              this.ref.close();
            },
            () => {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Service reminder created',
                key: 'service_reminder',
              });

              this.ref.close(data);
            }
          );
      });
  }
}
